import { Component, OnInit, Input } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'app-sincronizar-progresos',
  templateUrl: './sincronizar-progresos.component.html',
  styleUrls: ['./sincronizar-progresos.component.css']
})
export class SincronizarProgresosComponent implements OnInit {

  confirmar: number = 0;
  textoConfirmacion: string;

  constructor(
    private afs: AngularFirestore,
  ) { }

  @Input() id: string;
  @Input() contenido: any[];

  ngOnInit(): void { 
    
  }

  actualizar() {
    
    this.afs.collection('progresos').ref.where('idSesiones', '==' ,this.id).get().then(response => {
      response.docs.forEach((doc) => {
        let nuevoProgreso = [];
        const data = doc.data();
        const progreso = data['progreso']; 
        for (let index = 0; index < this.contenido.length; index++) {
          if(this.contenido[index].vigente == true) {
            let completado = 0
            for (let indexViejo = 0; indexViejo < progreso.length; indexViejo++) {
              if(this.contenido[index].id == progreso[indexViejo].progreso.id){
                completado = progreso[indexViejo].completado
              };              
            }
            nuevoProgreso = nuevoProgreso.concat({
              'completado': completado,
              'progreso': this.contenido[index],
            })
            nuevoProgreso = nuevoProgreso.sort((a,b) => a.progreso.numero - b.progreso.numero)
          }
        }
        this.afs.collection('progresos').doc(doc.id).update({
          'progreso':nuevoProgreso,
        }).then(() => {
          alert('Curso Sincronizado')
        }).catch(error => {
          alert(error)
        })
      })
    })
  }

  ponerId() {
    this.afs.collection('sesiones').ref.get().then(response => {
      response.docs.forEach((doc) => {
        const data = doc.data();
        const contenido = data['contenido'];
        for (let index = 0; index < contenido.length; index++) {
          const element = contenido[index];
          element.id = index + 1;  
          element.vigente = true;        
        }
        this.afs.collection('sesiones').doc(doc.id).update({
          'contenido': contenido,
        }).then(() => {
          alert('listos id')
        }).catch(error => {
          alert(error)
        })
      })
    })
  }

}
